import logWebHeaderUpgradeToProTapped from '@alltrails/analytics/events/logWebHeaderUpgradeToProTapped';
import useUser from 'hooks/useUser';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import WebHeaderUpgradeToProCopyText from '@alltrails/analytics/enums/WebHeaderUpgradeToProCopyText';
import Link from '@alltrails/shared/denali/components/Link';
import * as styles from './MobileHomeLink.module.scss';

export default function MobileHomeLink() {
  const user = useUser();

  if (!user) {
    return (
      <Link className={styles.link} size="sm" href="/plus" testId="headerSignUp">
        <FormattedMessage defaultMessage="Try AllTrails+" />
      </Link>
    );
  }

  if (!user.pro) {
    return (
      <Link
        className={styles.link}
        size="sm"
        href="/plus"
        testId="get-plus-mobile-home-link"
        onClick={() => {
          logWebHeaderUpgradeToProTapped({
            copy_text: user.isPromoEligible ? WebHeaderUpgradeToProCopyText.TryProFree : WebHeaderUpgradeToProCopyText.UpgradeToPro
          });
        }}
      >
        {user.isPromoEligible ? <FormattedMessage defaultMessage="Try AllTrails+" /> : <FormattedMessage defaultMessage="Get AllTrails+" />}
      </Link>
    );
  }

  return null;
}
